/* eslint-disable max-len */
export const payment = {
  enterAmountMoreThan: 'Enter amount more than :amount',
  transactions: 'Transactions',
  numberLenghtErr: 'Lenght of bank number should be 12-19',
  balance: 'Balance',
  number: 'Number',
  all: 'All',
  withdrawDescription:
    'Attention! Due to technical problems, payments to the bank account may be delayed. We apologize for the inconvenience caused!',
  withdrawalRequestedCompleted: 'Withdrawal requested successfully',
  depositCompleted: 'Deposit completed',
  withdrawalCompleted: 'Withdrawal completed',
  depositWithMethod: 'Deposit: (Method name)',
  userId: 'User id:',
  transactionId: 'Transaction id:',
  clientPhone: 'Client phone number:',
  agentNumber: 'Agent number:',
  time: 'Time',
  selectPaymentSystemMethods: {
    card: 'Card',
    crypto: 'USDT',
  },
  commission: 'Commission',
  recommendedMethods: 'Recommended methods',
  withdraw: 'Withdraw',
  sipsak_card: 'Sipsak',
  chooseMethod: 'Choose a method',
  next: 'Next',
  transferAtLeast: 'Transfer at least',
  toThisAccountWarning: 'to this account to this address or your payment will not go through',
  cashOut: 'Cash out',
  yourBalance: 'Your balance',
  payQrCode: 'Make a payment using this QR code within',
  cancelPayment: 'Cancel payment',
  copy: 'Copy',
  copied: 'Copied!',
  importantNotice: 'Important notice',
  depositInfo:
    'If your deposit via bKash, Nagad, Rocket and Upay is not added to your account within 2 hours, please contact the above email:',
  writingFormat: 'Writing format',
  selectCashier: 'Select cashier',
  depositInfoBottom:
    'For faster solution, please refrain from sending the same problem repeatedly, sending it repeatedly will take us longer to resolve the problem.',
  expiredDeposit: 'The deposit has expired by time',

  transactionStatuses: {
    ALL: 'All',
    all: 'All',
    COMPLETED: 'Completed',
    OPEN: 'Open',
    IN_PROCESS: 'Waiting',
    REJECTED: 'Rejected',
    CANCELLED: 'Cancelled',
    Success: 'Success',
    Started: 'In process',
    Failed: 'Failed',
    Canceled: 'Canceled',
    ManualApprovingRequired: 'In process',
    Approving: 'Success',
    ApprovingSuccess: 'Success',
    ApprovingFailed: 'Failed',
    ManualProcessRequired: 'In process',
    Frozen: 'Frozen',
    Expired: 'Expired',
    CanceledByUser: 'Canceled',

    success: 'Success',
    in_process: 'In process',
    frozen: 'Frozen',
    expired: 'Expired',
    canceled: 'Canceled',
    failed: 'Failed',
  },
  setTopUpMethod: 'Choose one of the replenishment methods',
  setWitdrawalpMethod: 'Choose one of the withdrawal methods',
  setAmount: 'Indicate the amount to replenish:',
  setAmountWithdrawal: 'Indicate the amount for withdrawal:',
  setReqWithdrawal: 'Indicate details:',
  topUp: 'TopUp account',
  topUpRules: 'Rules of replenishment',
  amount: 'Amount',
  phone: 'Phone number',
  phoneRegulation: 'Enter a phone number in international format',
  interkassa: 'Interkassa',
  freeKassa: 'Free-Kassa',
  visa: 'VISA',
  page: 'Page',
  qiwi: 'QIWI',
  mastercard: 'Mastercard',
  yandexMoney: 'Yandex Money',
  payHistory: 'Operations history',
  backToProfile: 'Back to profile',
  litecoin: 'Litecoin',
  bitcoin: 'Bitcoin',
  payeer: 'Payeer',
  perfectMoney: 'Perfect Money',
  advcash: 'AdvCash',
  mts: 'МТС',
  beeline: 'Beeline',
  tele2: 'Tele 2',
  megafon: 'MegaFon',
  webmoney: 'WebMoney',
  replenish: 'Replenish',
  withdrawal: 'Withdrawal',
  withdrawalMoney: 'Withdrawal money',
  withdrawalRules: 'Withdrawal rules',
  withdrawalParagraph1: 'To withdraw funds, you must perform the following steps:',
  withdrawalParagraph2: 'The minimum amount to withdrawal 15$.',
  withdrawalItem1: '1. Choose pay system',
  withdrawalItem2: '2. Enter details and amount',
  withdrawalItem3: '3. Press the withdrawal button',
  requisites: 'Requisites',
  id: 'Id',
  date: 'Date',
  operationType: 'Operation type',
  status: 'Status',
  success: 'Success',
  minAmount: 'Select an amount greater than the minimum',
  reject: 'Successfully rejected',
  withdrawalSuccess: 'Withdrawal ordered successfully',
  errorPayment: 'Currently only replenishment of ruble accounts is possible',
  amountLess: 'Amount less than minimal',
  requestSended: 'A request for replenishment has been sent to your qiwi wallet',
  accountStatement: 'Account statement',
  transactionType: 'Transaction type',
  selectPeriod: 'Select period',
  from: 'From',
  to: 'To',
  selectTransactionType: 'Select transaction type',
  showAll: 'Show all transaction type',
  show: 'Show',
  deposit: 'Deposit',
  description: 'Description',
  name_and_surname: 'Name and Surname',
  account_number: 'Account Number',
  identity_number: 'Identity Number',
  technicalDescription:
    'Please be informed that due to maintenance of banks, at midnight deposits from accounts may be delayed up to 30 minutes.',
  limits: 'Limits',
  max: 'max',
  min: 'min',
  send: 'Send',
  AllPayment: 'All',
  noData: 'No data',
  withdrawalStatuses: {
    ALL: 'All',
    OPEN: 'Created',
    IN_PROCESS: 'During',
    COMPLETED: 'Paid out',
    BLOCKED: 'Blocked',
    REJECTED: 'Canceled',
  },
  paymentSystemList: {
    1: 'Alikassa',
    2: 'Revalcoin',
    revalcoin: 'Revalcoin',
    constant: 'Constant',
  },
  paymentStatuses: {
    10: 'Started',
    20: 'Requested',
    21: 'Approved',
    22: 'Approving failed',
    27: 'Manual process required',
    30: 'Success',
    40: 'Failed',
    45: 'Expired',
  },
  transactionTypes: {
    deposit: 'Deposit',
    all: 'All',
    payout: 'Withdraw',
  },
  createdAt: 'Created at',
  amountCurrency: 'Currency',
  paymentSystem: 'Payment system',
  promocodeSuccess: 'Promo code successfully activated',
  promocode: 'Promo code',
  activatePromocode: 'Activate promo code',
  activate: 'Activate',
  payouts: 'Payouts',
  deposits: 'Deposits',
  continue: 'Continue',
  confirm: 'Confirm',
  copyThisAddresOrScanQr: 'Copy this address or scan this QR-code',
  minimumPaymentAmount: 'Minimum payment amount',
  Manualprocessrequired: 'In processing',
  Waiting: 'In processing',
  Started: 'In processing',
  Finished: 'Success',
  type: 'Type',
  payout: 'Withdrawals',
  payoutCanceledSuccess: 'Payout have been canceled successfully',
  cancel: 'Cancel',
  dateFrom: 'Date from',
  dateTo: 'Date to',
  address: 'Address',
  firstName: 'First name',
  lastName: 'Last name',
  inputNameAttention: 'Enter valid data, VISA/MASTERCARD top-up requires KYC verification',
  'Bank Transfer_cash': 'Bank Transfer',

  maxFileNameLength: 'Maximum file name length $FILE_NAME_LENGTH characters',
  fileTypeMustBe: 'File type must be one of $FILES_TYPE',
  maxImageResolution: 'Maximum image resolution: $IMAGE_RESOLUTION pixels',
  uploadOneScreen: 'Upload at least one screenshot',
  upload: 'Upload',
  uploadPhoto: 'Upload photo',
  fileIsTooBig: 'File is too big',
  maxSizes: 'Max sizes $MAX_SIZE',
  uploadPaymentScreens: 'Upload payment screenshots',
  pleaseUploadImage:
    'Please upload an image in JPEG or PNG format. No longer than $MAX_SIZE with resolution to 1920x1080 pixels',
}
